/**
 * OGP (Open Graph Protocol) related constants
 */
export const OgpImageUrl = "https://yoyacoo.jp/customer/lp/banner.png";
